export enum Status {
  active = 'active',
  inactive = 'inactive',
  expired = 'expired',
  underReview = 'under_review',
  pending = 'pending',
  disabled = 'disabled'
}
export type StatusFilterValue = Status;

export type FiltersState = {
  status: StatusFilterValue[] | null;
};

export type Category = {
  id: number;
  key: string;
  name: string;
  label: string;
  level: number;
  parentId: number;
  nestedIds: number;
  children?: Category[];
};
